// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { io } from "socket.io-client";

const socket = io();          // connects to the same origin
window.socket = socket;       // expose globally for any component

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);